'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    selectedSlagId?: string;
    selectedElectionId?: string;
    isSettingsDisabled?: boolean;
};

const Client = (props: Readonly<Props>) => {
    const { selectedSlagId, selectedElectionId, isSettingsDisabled } = props;

    useEffect(() => {
        const { companyStore, generalSettingsStore } = getStore();

        if (selectedSlagId !== undefined) {
            companyStore.setSelectedSlagId(selectedSlagId);
        }
        if (selectedElectionId !== undefined) {
            generalSettingsStore.setSelectedElectionId(selectedElectionId);
            generalSettingsStore.setPreSelectElectionId(selectedElectionId);
        }
        if (isSettingsDisabled !== undefined) {
            generalSettingsStore.setIsSettingsDisabled(isSettingsDisabled);
        }
    }, [selectedSlagId, selectedElectionId, isSettingsDisabled]);

    return null;
};

export default Client;
